module.exports = __webpack_public_path__ + "img/06-title.ee23a245.png";